'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import React from 'react';
import { trackMetaPixel } from '@/lib/metaPixel';

export function MetaPixelPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const hasTrackedInitialPageView = React.useRef(false);

  React.useEffect(() => {
    if (!hasTrackedInitialPageView.current) {
      hasTrackedInitialPageView.current = true;
      return;
    }

    trackMetaPixel('PageView');
  }, [pathname, search]);

  return null;
}
